var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Radar50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#33691e",
    d: "M44,24c0,11-9,20-20,20S4,35,4,24S13,4,24,4S44,13,44,24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#689f38",
    d: "M25,4.1C24.7,4,24.3,4,24,4s-0.7,0-1,0.1V23H4.1C4,23.3,4,23.7,4,24s0,0.7,0.1,1H23v18.9 c0.3,0,0.7,0.1,1,0.1s0.7,0,1-0.1V25h18.9c0-0.3,0.1-0.7,0.1-1s0-0.7-0.1-1H25V4.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#689f38",
    d: "M24,32c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S28.4,32,24,32z M24,18c-3.3,0-6,2.7-6,6s2.7,6,6,6 s6-2.7,6-6S27.3,18,24,18z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#689f38",
    d: "M24,39c-8.3,0-15-6.7-15-15c0-8.3,6.7-15,15-15c8.3,0,15,6.7,15,15C39,32.3,32.3,39,24,39z M24,11 c-7.2,0-13,5.8-13,13c0,7.2,5.8,13,13,13c7.2,0,13-5.8,13-13C37,16.8,31.2,11,24,11z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#c6ff00",
    d: "M26 24c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2S26 22.9 26 24zM16 33.5c0 1.4-1.1 2.5-2.5 2.5S11 34.9 11 33.5s1.1-2.5 2.5-2.5S16 32.1 16 33.5zM16 14.5c0 1.4-1.1 2.5-2.5 2.5S11 15.9 11 14.5s1.1-2.5 2.5-2.5S16 13.1 16 14.5zM35 34.5c0 .8-.7 1.5-1.5 1.5S32 35.3 32 34.5s.7-1.5 1.5-1.5S35 33.7 35 34.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#c6ff00",
    d: "M24,25c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4L36.7,9.9c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4 L24.7,24.7C24.5,24.9,24.3,25,24,25z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Radar50);
export default __webpack_public_path__ + "static/media/icons8-radar-50.d496055cc9b6fb7e55f36f2a1bbb56b7.svg";
export { ForwardRef as ReactComponent };